import { render } from "./CreateHelpRequest.vue?vue&type=template&id=f575a6b2"
import script from "./CreateHelpRequest.vue?vue&type=script&lang=js"
export * from "./CreateHelpRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__